import { render } from "./IconFilterArrowDonw.vue?vue&type=template&id=380a09da"
import script from "./IconFilterArrowDonw.vue?vue&type=script&lang=js"
export * from "./IconFilterArrowDonw.vue?vue&type=script&lang=js"
script.render = render

export default script